$(document).ready(function () {
  var phoneInput = $('.phone-number-input');

  if (!phoneInput.length) return;

  var preferredCountries = phoneInput.data('preferred-countries') || ['FR', 'BE', 'CH', 'LU'];
  if (typeof preferredCountries === 'string') {
    preferredCountries = JSON.parse(preferredCountries);
  }

  phoneInput.intlTelInput({
    initialCountry: 'FR',
    preferredCountries: preferredCountries,
    separateDialCode: true,
    formatOnDisplay: true,
    autoHideDialCode: false,
    nationalMode: false,
    hiddenInput: 'full',
  });

  phoneInput.closest('form').on('submit', function (e) {
    phoneInput.removeClass('error');
    if (phoneInput.intlTelInput('isValidNumber') &&
      [
        intlTelInputUtils.numberType.MOBILE,
        intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE,
      ].includes(phoneInput.intlTelInput('getNumberType'))) {
      phoneInput.val(phoneInput.intlTelInput('getNumber'));
    } else {
      var currentLocale = getCurrentLocale();
      var errorMessage = {
        fr: 'Le numéro renseigné doit correspondre à un téléphone mobile.',
        en: 'Please fill in a mobile phone number.',
        es: 'El número de teléfono debe ser un número de móvil.',
      };

      toastr.error(errorMessage[currentLocale]);

      e.preventDefault();
      phoneInput.addClass('error');
      return false;
    }
  });

  var tax_location_different_from_residence_input = $(
    '#users_profile_user_attributes_tax_location_different_from_residence'
  );

  if (tax_location_different_from_residence_input.length) {
    tax_location_on_change = function () {
      if ($('#users_profile_user_attributes_tax_location_different_from_residence').prop('checked')) {
        $('.tax-location-form-container').removeClass('d-none');
        $('.tax-location-form-container .is_required').attr('required', 'required');
        $('#destroyTaxLocation').val('0');
      } else {
        $('.tax-location-form-container').addClass('d-none');
        $('.tax-location-form-container .is_required').attr('required', false);
        $('#destroyTaxLocation').val('1');
      }
    }

    tax_location_different_from_residence_input.on('change', tax_location_on_change);
    tax_location_on_change();
  }
});
